export default {
  //支持添加数据时向外抛出事件
  customChange: {
    type: Boolean,
    default: false,
  },
  //id标示
  idPrefix: {
    type: String,
    default: '',
  },
  // 轻型药械善加请求参数,json格式或者对象
  fAMLightRequestParam: {
    type: [Object],
    default: null,
  },
  medicalUrl: {
    type: String,
    default: '',
  },
  getConverDataUrl: {
    type: String,
    default: '',
  },
  changeFun: {
    type: Boolean,
    default: false,
  },
  // placeholder: {
  //   type: String,
  //   default: '选择',
  // },
  selection: {
    type: Boolean,
    default: true,
  },
  title: {
    type: String,
    default: '编辑',
  },
  sideModalWidth: {
    type: [String, Number],
  },
  sideModalSecondWidth: {
    type: [String, Number],
  },
  choiceSideModalTitle: {
    type: String,
    default: '请选择',
  },
  sideModalBtn: {
    type: String,
    default: '确定',
  },
  menuAddName: {
    type: String,
    default: '增加',
  },
  menuRemoveName: {
    type: String,
    default: '删除',
  },
  menuAddShow: {
    type: Boolean,
    default: true,
  },
  menuCopyAddShow: {
    type: Boolean,
    default: true,
  },
  menuDeleteShow: {
    type: Boolean,
    default: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  value: {
    type: [Array],
    default: () => [],
  },
  indexLabel: {
    type: String,
    default: '序号',
  },
  // 表单配置请求URL
  urlItemsDef: {
    type: String,
    default: null,
  },
  customColumn: {
    type: Boolean,
    default: false,
  },
  tableColumnCode: {
    type: String,
    default: null,
  },
  tableColDefaultUrl: {
    type: String,
    default: 'rest/main/dict/getTableByCode?tableCode=',
  },
  //列表定义配置获取URL(配置该项时tableColumnCode和tableColDefaultUrl失效)
  tableColumnDefUrl: {
    type: String,
    default: null,
  },
  // 列表定义配置
  tableColumnDef: {
    type: Object,
  },
  removeAll: {
    type: Boolean,
    default: false,
  },

  menuAddChooseShow: {
    type: Boolean,
    default: false,
  },
  menuAddChooseName: {
    type: String,
    default: '添加',
  },
  menuAddChooseModalTitle: {
    type: String,
    default: '请选择',
  },
  menuAddChooseUrl: {
    type: String,
    default: '',
  },
  menuAddChooseIndex: {
    type: Boolean,
    default: true,
  },
  menuAddChooseRequestMethod: {
    type: String,
    default: 'post',
  },
  // 请求参数,json格式或者对象
  menuAddChooseRequestParam: {
    type: [String, Object],
    default: null,
  },
  menuAddChooseSearchKey: {
    type: String,
    default: 'keyword',
  },
  menuAddChooseTableColumnDef: {
    type: Array,
    default: () => {
      return [
        {
          prop: 'code',
          label: '编码',
        },
        {
          prop: 'name',
          label: '名称',
        },
      ]
    },
  },
  menuAddChooseplaceholder: {
    type: String,
    default: '请输入',
  },

  menuChooseName: {
    type: String,
    default: '选择',
  },
  menuChooseNameDisabled: {
    type: Boolean,
    default: false,
  },
  chooseUrl: {
    type: String,
    default: '',
  },
  chooseIndex: {
    type: Boolean,
    default: true,
  },
  chooseRequestMethod: {
    type: String,
    default: 'post',
  },
  // 请求参数,json格式或者对象
  chooseRequestParam: {
    type: [String, Object],
    default: null,
  },
  chooseSearchKey: {
    type: String,
    default: 'keyword',
  },

  chooseTableColumnDef: {
    type: Array,
    default: () => {
      return [
        {
          prop: 'code',
          label: '编码',
        },
        {
          prop: 'name',
          label: '名称',
        },
      ]
    },
  },

  addDefaultData: {
    type: Object,
    default: () => {},
  },
  addInitialData: {
    type: Object,
    default: () => {},
  },
  //复制时清空id的key
  copyId: {
    type: String,
    default: 'id',
  },
  // 自定义操作栏表头名称
  operateCell: {
    type: String,
    default: '操作',
  },
  // 自定义判重字段
  convertArray: {
    type: Array,
    default: () => [],
  },
  // 是否启用自定义判重字段
  isConvertArray: {
    type: Boolean,
    default: false,
  },
  showSortBatch: {
    type: Boolean,
    default: false,
  },
  checkField: {
    type: String,
    default: 'id',
  },
  paddingTop: {
    type: [String, Number],
    default: '15',
  },
  placeholder: {
    type: String,
    default: '请输入',
  },
  // 复制新建的最大个数
  tableMaxLength: {
    type: String,
    default: '',
  },
  openValidation: {
    type: Boolean,
    default: true,
  },
  // 启用校验时候，指定校验的key
  rowDataKey: {
    type: String,
    default: 'items',
  },
  calculateTotal: {
    type: Boolean,
    default: false,
  },
  showFlashAddMedicalLight: {
    type: Boolean,
    default: false,
  },
  isShowSummary: {
    type: Boolean,
    default: true,
  },
  draggable: {
    type: Boolean,
    default: true,
  },
  useMaster: {
    type: Boolean,
    default: false,
  },
  // 是否采用该组件本身的删除方法
  isUseOwnRemoveFn: {
    type: Boolean,
    default: false,
  },
  indexPageNo: {
    type: Number,
    default: 1,
  },
  indexPageSize: {
    type: Number,
    default: 0,
  },
  height: {
    type: [String, Number],
  },
  radioPropertyPath: {
    type: String,
    default: null,
  },
  enableCellEdit: {
    // 是否启用表格单元格编辑 默认启用
    type: Boolean,
    default: true,
  },
  showTopCopy: {
    // 是否显示顶部 复制选中数据
    type: Boolean,
    default: false,
  },
  store: {
    //传递store
    type: Object,
    default: null,
  },
  //删除按钮是否提示信息
  customDeleteConfim: {
    type: Boolean,
    default: false,
  },
  extendData: {
    type: Object,
    default: null,
  },
  /**
   * #7231, 直接显示在【操作】栏的按钮
   * {
      "icon": "ivu-icon-icon-pg-edit",
      "name": "更新单位",
      "type": "method",
      "param": {
        "methodName": "updateUnit"
      },
      "cssType": "",
      "showExp": true,
      "children": null,
      "enableExp": "enableExp"
    }
   */
  // shortcutButtons: {
  //   type: Array,
  //   default() {
  //     return []
  //   },
  // },
  // 只显示 shortcut button。注意 shortcutButtons.length > 0 时，此字段为 true 才有效
  // onlyShortcutButton: {
  //   type: Boolean,
  //   default: false,
  // },
}
